import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class VersionService {
  private readonly version: string;

  constructor() {
    // APP_VERSION is injected by webpack DefinePlugin at build time
    this.version = typeof APP_VERSION !== 'undefined' ? APP_VERSION : 'dev';
  }

  getVersion(): string {
    return this.version;
  }
}